const cancelacionInitialState = {
    cancelacion: {
      loading: false,
      error: null,
      data: null,
      validaCancelacion: null,
      cancelaTurno: null,
      lugarInicio: false
    },
  };
  
  export default cancelacionInitialState;
  